import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faBuilding,
  faBox,
  faFileDownload,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import axios from "axios";
import fileDownload from "js-file-download";
import { TimeSpanSelector } from "../../components/ui/time-span-selector";
import { useAppSelector } from "../../reducers/store";

export function ApprovalList(props: {
  approvalList: any[];
  listType: string;
  onApprove: (approval: any) => void;
  onDenied: (approval: any) => void;
  setIsSubLoading: (value: boolean) => void;
  isSubLoading: boolean;
  handleButtonClick: (
    data?: string,
    customStartDate?: string,
    customEndDate?: string,
  ) => void;
}) {
  const approvalList = props.approvalList;
  const [selectedDays, setSelectedDays] = useState("30d");
  const [dateFilter, setDateFilter] = useState("30d");

  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");

  const handleDownload = (url: string, filename: string) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      });
  };

  const handleTimeSpanChange = (
    data: string,
    customStartDate?: string,
    customEndDate?: string,
  ) => {
    if (customStartDate && customEndDate) {
      setSelectedDays("custom");
      setDateFilter("custom");

      setCustomStartDate(customStartDate);
      setCustomEndDate(customEndDate);
    } else if (data !== "custom") {
      setSelectedDays(data);
      setDateFilter(data);

      setCustomStartDate("");
      setCustomEndDate("");
    }

    props.setIsSubLoading(true);
    props.handleButtonClick(data, customStartDate, customEndDate);
  };

  useEffect(() => {}, []);

  return (
    <div className="flex max-h-[100%] min-h-[100%] w-[100%] flex-row flex-wrap gap-x-[10px] px-[20px] py-[15px] text-[black]">
      {props.listType !== "pending" && (
        <div className="mb-10 flex w-full flex-row justify-end">
          {props.listType !== "pending" && (
            <TimeSpanSelector
              selectedDays={selectedDays}
              customStartDate={customStartDate}
              customEndDate={customEndDate}
              handleButtonClick={handleTimeSpanChange}
            />
          )}
        </div>
      )}

      {props.isSubLoading && (
        <div className="absolute inset-0 z-10 mt-48 flex items-center justify-center bg-white bg-opacity-50 backdrop-blur-sm">
          <span className="loading loading-spinner h-[40px] w-[40px] text-tqsYellow"></span>
        </div>
      )}

      {approvalList.length > 0 &&
        !props.isSubLoading &&
        approvalList.map((item) => (
          <div
            key={item.id}
            className="mb-[15px] w-[100%] rounded-[8px] border border-gray-300 px-[35px] py-[20px]"
          >
            {/* top of card */}
            <div>
              <div className="flex items-center">
                <h4 className="text-[20px] font-semibold text-[#212322]">
                  {item?.hours}{" "}
                  {item?.hours > 1 ? "ADDITIONAL HOURS" : "ADDITIONAL HOUR"}{" "}
                  <span>- {item?.reason}.</span>
                </h4>
                {item?.approved == true && (
                  <span className="px-[8px] font-semibold text-tqsGreen">
                    Approved
                  </span>
                )}
                {item?.approved == false && (
                  <span className="px-[8px] font-semibold text-tqsRed">
                    Denied
                  </span>
                )}
              </div>
              <div>
                <p>
                  {moment(item?.time).format("dddd")},{" "}
                  {moment(item?.time).format("MMM Do YYYY")}
                </p>
              </div>
            </div>

            {/* Middle of the card */}
            <div>
              <div className="flex gap-[20px]">
                <p>
                  <FontAwesomeIcon
                    icon={faUser}
                    className="mr-[4px] text-[14px]"
                  />{" "}
                  {item?.createUser?.firstName} {item?.createUser?.lastName}
                </p>
                <p>
                  <FontAwesomeIcon
                    icon={faBuilding}
                    className="mr-[4px] text-[14px]"
                  />{" "}
                  {item?.location?.name}
                </p>
                <p>
                  <FontAwesomeIcon
                    icon={faBox}
                    className="mr-[4px] text-[14px]"
                  />{" "}
                  {item?.supplier?.name}
                </p>
              </div>
            </div>

            {/* bottom side of card */}
            <div className="mt-[10px] border-t border-gray-300 pt-[10px]">
              {item && item?.approved == null && (
                <div className="flex gap-[20px]">
                  <button
                    className="rounded-md bg-tqsLightGreen px-8 py-1 text-sm font-semibold text-tqsGreen"
                    onClick={() => props.onApprove(item)}
                  >
                    Approve
                  </button>
                  <button
                    className="rounded-md bg-tqsLightRed px-8 py-1 text-sm font-semibold text-tqsRed"
                    onClick={() => props.onDenied(item)}
                  >
                    Decline
                  </button>
                </div>
              )}
              {item && item?.approved == true && (
                <div>
                  <p>
                    {" "}
                    {item?.attachments?.length <= 0
                      ? "Approved by"
                      : "Approval uploaded by"}{" "}
                    {item?.approvedByName
                      ? item?.approvedByName
                      : item?.approvedBy
                        ? item?.approvedBy
                        : "Representative"}{" "}
                    on{" "}
                    {item?.approvedTime
                      ? moment(item?.approvedTime).format(
                          "MMMM Do YYYY, h:mm:ss a",
                        )
                      : moment(item?.createTime).format(
                          "MMMM Do YYYY, h:mm:ss a",
                        )}
                  </p>
                  {item?.attachments?.length > 0 && (
                    <div className="mt-[10px]">
                      <h4>Attachments:</h4>
                      {item?.attachments?.map(
                        (attachment: any, index: number) => (
                          <div
                            key={`${attachment.attachment.filename}-${index}`}
                          >
                            <span className="text-[14px] underline">
                              <a
                                target="_blank"
                                href={attachment?.attachment?.downloadURL}
                              >
                                {attachment?.attachment?.filename}
                              </a>
                            </span>
                            <span>
                              <a
                                className="cursor-pointer"
                                onClick={() =>
                                  handleDownload(
                                    attachment?.attachment?.downloadURL,
                                    attachment?.attachment?.filename,
                                  )
                                }
                              >
                                <FontAwesomeIcon
                                  icon={faFileDownload}
                                  className="ml-[4px] text-[14px]"
                                />
                              </a>
                            </span>
                          </div>
                        ),
                      )}
                    </div>
                  )}
                </div>
              )}
              {item?.approved == false && (
                <div>
                  <p>
                    Denied by{" "}
                    {item?.approvedByName
                      ? item?.approvedByName
                      : item?.approvedBy
                        ? item?.approvedBy
                        : "Representative"}{" "}
                    on{" "}
                    {moment(item?.approvedTime).format(
                      "MMMM Do YYYY, h:mm:ss a",
                    )}
                  </p>
                  <p>Denial Reason: {item.denialReason}</p>
                </div>
              )}
            </div>
          </div>
        ))}

      {approvalList.length == 0 && (
        <div className="flex w-[100%] justify-center py-3">
          {props.listType == "pending" && (
            <h1 className="text-[20px] font-semibold text-[#212322]">
              There are currently no Pending Approvals at this time.
            </h1>
          )}
          {props.listType == "approved" && (
            <h1 className="text-[20px] font-semibold text-[#212322]">
              There are currently no Approved Approvals at this time.
            </h1>
          )}
          {props.listType == "denied" && (
            <h1 className="text-[20px] font-semibold text-[#212322]">
              There are currently no Denied Approvals at this time.
            </h1>
          )}
          {props.listType == "all" && (
            <h1 className="text-[20px] font-semibold text-[#212322]">
              There are currently no Approvals at this time.
            </h1>
          )}
        </div>
      )}
    </div>
  );
}
